"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalBackgroundWrapper = exports.DescriptionWrapper = exports.ModalWrapper = exports.CloseButtonWrapper = exports.ButtonsWrapper = exports.Title = exports.ModalBodyContainer = exports.IconContainer = exports.ModalContentWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.ModalContentWrapper = styled_components_1.default.div `
    background: white;
    width: 40%;
    height: fit-content;
    margin: 24px;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 12px;
        height: 0.5em;
    }

    &::-webkit-scrollbar-thumb {
        background: ${colors_1.GREY2};
        border-radius: 22px;
    }
`;
exports.IconContainer = styled_components_1.default.div `
    margin: 16px 16px 0px 40px;
    display: flex;
    flex-direction: row-reverse;
`;
exports.ModalBodyContainer = styled_components_1.default.div `
    margin: 0px 40px 0px 40px;
`;
exports.Title = styled_components_1.default.span `
    font-family: SwegonBrown;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 32px;
    display: flex;
    flex-wrap: wrap;
`;
exports.ButtonsWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: row-reverse;
    margin: 20px 0px 24px 0px;
`;
exports.CloseButtonWrapper = styled_components_1.default.div `
    margin-right: 5px;
`;
exports.ModalWrapper = styled_components_1.default.div `
    height: fit-content;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 11;
    display: flex;
    justify-content: center;
`;
exports.DescriptionWrapper = styled_components_1.default.div `
    display: flex;
    flex-wrap: wrap;
    font-family: SwegonBrown;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: ${colors_1.GREY4};
    text-align: justify;
`;
exports.ModalBackgroundWrapper = styled_components_1.default.div `
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    padding-top: 80px;
    justify-content: center;
    background-color: ${colors_1.BLACK};
    opacity: 0.7;
    z-index: 10;
`;
//# sourceMappingURL=MessageModal.styles.js.map